import { services } from './index';

export type AdminNotificationType =
  | 'kyc'
  | 'distribution'
  | 'user'
  | 'asset'
  | 'alert'
  | 'yield'
  | 'transaction'
  | 'compliance';

interface CreateNotificationParams {
  type: AdminNotificationType;
  title: string;
  message: string;
  priority?: 'low' | 'medium' | 'high';
  userId?: string;
  assetId?: string;
}

/**
 * Create an admin notification so it appears in the Notifications panel.
 * Fires and forgets – never throws so it won't break the main flow.
 */
export async function createAdminNotification(params: CreateNotificationParams): Promise<void> {
  try {
    await services.post<{ status: boolean; data?: unknown }>('/admin/notifications/create', {
      type: params.type,
      title: params.title,
      message: params.message,
      priority: params.priority ?? 'medium',
      ...(params.userId && { userId: params.userId }),
      ...(params.assetId && { assetId: params.assetId }),
    });
  } catch (err) {
    console.warn('[createAdminNotification] Failed to create notification:', err);
  }
}
